import { differenceInDays, format, isFuture } from 'date-fns/esm';

const COMPANY_DUE_DATE_KEY = 'companyDueDate';

// Tolerância aplicada sobre o vencimento antes do bloqueio de acesso
// ("10 dias pro calango se organizar").
const GRACE_DAYS = 10;

// Vencimento efetivo = dueDate + tolerância. Base para o bloqueio de acesso.
const getEffectiveDueDate = (rawDueDate: string): Date => {
    const dueDate = new Date(rawDueDate);
    dueDate.setDate(dueDate.getDate() + GRACE_DAYS);
    return dueDate;
};

// Dias restantes com base no dueDate cru (sem tolerância) — alimenta os banners
// de aviso. Lê sempre o valor mais recente do localStorage.
export const getRemainingDaysToExpire = (): number => {
    const dueDate = new Date(
        localStorage.getItem(COMPANY_DUE_DATE_KEY) as string
    );
    return differenceInDays(dueDate, new Date());
};

// Conta vencida = passou do vencimento + tolerância. Mesma regra usada no login.
export const isMembershipExpired = (rawDueDate: string): boolean =>
    !isFuture(getEffectiveDueDate(rawDueDate));

// Data efetiva de vencimento formatada, exibida nos avisos ao usuário.
export const formatEffectiveDueDate = (rawDueDate: string): string =>
    format(getEffectiveDueDate(rawDueDate), 'dd/MM/yyyy');

// Mantém o dueDate cacheado sempre atualizado (no login e a cada refresh),
// para que a informação de vencimento não fique defasada em sessões longas.
export const persistCompanyDueDate = (rawDueDate: string): void => {
    localStorage.setItem(COMPANY_DUE_DATE_KEY, rawDueDate);
};
